import { query } from '@confluence/query-preloader-tools/entry-points/graphql';
import { FeatureDiscoveryQuery } from '@confluence/feature-discovery/entry-points/FeatureDiscoveryQuery';

export const preloadFeatureDiscovery = () => {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: FeatureDiscoveryQuery,
	});
};
